import {Box, BoxProps, Typography} from "@mui/material";
import React, {FC, useMemo} from "react";
import {makeStyles} from "tss-react/mui";
import {useGetMe} from "@/app2/shared/data";

const useStyles = makeStyles()(() => ({
	profileImage: {
		overflow: "hidden",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		"img": {
			height: "100%",
			maxHeight: "100%",
			maxWidth: 2000,
			width: "100%",
			objectFit: "cover"
		}
	},
	initials: {
		fontWeight: 600,
		fontSize: "0.875rem",
		lineHeight: 1,
		userSelect: "none"
	}
}));

type IProps = Omit<BoxProps, "children">;

export const ProfileImage: FC<IProps> = ({className, ...props}) => {
	const {data: user} = useGetMe();
	const {classes, cx} = useStyles();
	const profileImage = user?.profileImage;

	const initials = useMemo(() => {
		const first = user?.firstname?.trim()?.charAt(0);
		const last = user?.lastname?.trim()?.charAt(0);
		if (first || last) return `${first ?? ""}${last ?? ""}`.toUpperCase();
		const email = user?.email?.trim();
		if (email) return email.charAt(0).toUpperCase();
		return "?";
	}, [user?.firstname, user?.lastname, user?.email]);

	return (
		<Box className={cx(classes.profileImage, className)} {...props}>
			{profileImage ? (
				<img width="200" height="200" alt="" src={profileImage}/>
			) : (
				<Typography component="span" className={classes.initials} aria-hidden>
					{initials}
				</Typography>
			)}
		</Box>
	);
};
